import { type FC } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  useDisclosure
} from '@chakra-ui/react';
import {
  // UiBox,
  // UiHStack,
  type UiHStackProps,
  UiIconPlusCircle,
  UiStack,
  uiStyles,
  UiHStack, UiText,
  // UiGrid,
} from '@/lib/ui';
import { generatePageUrl } from '@/app/pages';
import TeamForm from './TeamForm';
import BaseButtonIconText from '@/base/Button/IconText';

export interface NewEventRowProps extends UiHStackProps {
}

const NewEventRow: FC<NewEventRowProps> = () => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <>
      <BaseButtonIconText Icon={UiIconPlusCircle} onClick={onToggle} variant={'large'}>Add team</BaseButtonIconText>
      <TeamForm
        onClose={onToggle}
        isVisible={isOpen}
        onSaveSuccess={() => {}}
      />
    </>
  );
};

export default NewEventRow;
